// Tailwind classes shared by the catalogue filter forms.
export const formClasses = {
  legendClass: "text-xs font-semibold uppercase tracking-wider text-slate-500",
  labelClass: "mb-1.5 block text-xs font-medium text-slate-600",
  inputClass:
    "block w-full rounded-lg border-slate-300 bg-white px-3 py-2 text-sm text-ink shadow-sm placeholder:text-slate-400 focus:border-brand focus:ring-2 focus:ring-brand/30",
  selectClass:
    "block w-full rounded-lg border-slate-300 bg-white py-2 pl-3 pr-10 text-sm text-ink shadow-sm focus:border-brand focus:ring-2 focus:ring-brand/30",
  checkboxClass:
    "h-4 w-4 rounded border-slate-300 text-brand focus:ring-brand/40",
};

export function chipClass(checked) {
  const base =
    "flex cursor-pointer select-none items-center gap-2.5 rounded-lg border px-3 py-2.5 text-sm font-medium transition-colors";
  return checked
    ? `${base} border-brand bg-brand-50 text-brand-700`
    : `${base} border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50`;
}

// Computed get/set pairs for each key of the form's v-model object, so the
// template can keep plain v-model on every input while the parent owns state.
export function fieldModels(keys) {
  return Object.fromEntries(
    keys.map((key) => [
      key,
      {
        get() {
          return this.modelValue[key];
        },
        set(value) {
          this.$emit("update:modelValue", {
            ...this.modelValue,
            [key]: value,
          });
        },
      },
    ])
  );
}
